import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const REFEREES_REQUEST = 'FETCH_REFEREES_REQUEST';
export const REFEREES_FAILURE = 'FETCH_REFEREES_FAILURE';
export const REFEREES_SUCCESS = 'FETCH_REFEREES_SUCCESS';

export const fetchReferees = () => {
    return function(dispatch) {
        dispatch(fetchRequest());
        return axios(apiRequestOptions(apiPath.REFEREE.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => {
    return { type: REFEREES_REQUEST }
};

const fetchFailure = (error) => {
    return { type: REFEREES_FAILURE, error }
};

const fetchSuccess = (data) => {
    return { type: REFEREES_SUCCESS, data }
};